import { render, staticRenderFns } from "./InputDateft.vue?vue&type=template&id=5d066064&"
import script from "./InputDateft.vue?vue&type=script&lang=js&"
export * from "./InputDateft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports